import { useState } from "react";
import { Box, TextField } from "@mui/material";

const OTPInput = ({ length = 4, onComplete }) => {
  const [otp, setOtp] = useState(new Array(length).fill(""));

  const handleChange = (index, value) => {
    if (!/^\d?$/.test(value)) return; // Only allow numbers

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < length - 1) {
      document.getElementById(`otp-${index + 1}`)?.focus();
    }

    if (newOtp.every((digit) => digit !== "") && onComplete) {
      onComplete(newOtp.join(""));
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      document.getElementById(`otp-${index - 1}`)?.focus();
    }
  };

  return (
    <Box display="flex" gap={1} justifyContent="center">
      {otp.map((digit, index) => (
        <TextField
          key={index}
          id={`otp-${index}`}
          value={digit}
          onChange={(e) => handleChange(index, e.target.value)}
          onKeyDown={(e) => handleKeyDown(index, e)}
          inputProps={{ maxLength: 1, style: { textAlign: "center" } }}
          sx={{ width: 50, "& input": { fontSize: "1.5rem" } }}
          variant="outlined"
          size="small"
        />
      ))}
    </Box>
  );
};

export default OTPInput;
